import {useDataStore} from "../Global/Utils/HookUtils";
import {PreferencesDataStore} from "../Global/DataStore/PreferencesDataStore";
import {SocketDataStore} from "../Global/DataStore/SocketDataStore";
import {default as React, useState} from "react";
import {Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip} from "@material-ui/core";
import {IoMdVolumeHigh, IoMdVolumeOff, MdPeople, MdSettings} from "react-icons/all";
import {GameRoster} from "../Areas/Game/Components/GameRoster";
import {GameSettings} from "../Areas/Game/Components/GameSettings";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => createStyles({
	settingsButton: {
		minWidth: 0,
		fontSize: "1.5rem",
	},
	firstButton: {
		minWidth: 0,
		marginLeft: "auto",
		fontSize: "1.5rem"
	},
	rosterButton: {
		minWidth: 0,
		fontSize: "1.5rem"
	},
}));

export const AppBarGameButtons = () =>
{
	const preferences = useDataStore(PreferencesDataStore);
	const socketData = useDataStore(SocketDataStore);
	const classes = useStyles();
	const [rosterOpen, setRosterOpen] = useState(false);
	const [settingsOpen, setSettingsOpen] = useState(false);

	const muteLabel = preferences.muted ? "Unmute" : "Mute";

	const buttonColor = preferences.darkMode ? "secondary" : "primary";

	return (
		<>
			<Tooltip title={`${muteLabel} game sounds`} arrow>
				<Button color={buttonColor} aria-label={"Share"} className={classes.firstButton} size={"large"} onClick={() => PreferencesDataStore.setMute(!preferences.muted)}>
					{preferences.muted && (
						<IoMdVolumeOff/>
					)}
					{!preferences.muted && (
						<IoMdVolumeHigh/>
					)}
				</Button>
			</Tooltip>
			<Tooltip title={"Scoreboard"} arrow>
				<Button color={buttonColor} aria-label={"Scoreboard"} className={classes.rosterButton} size={"large"} onClick={() => setRosterOpen(true)}>
					<MdPeople/>
				</Button>
			</Tooltip>
			<Tooltip title={"Game settings"} arrow>
				<Button color={buttonColor} aria-label={"Settings"} className={classes.settingsButton} size={"large"} onClick={() => setSettingsOpen(true)}>
					<MdSettings/>
				</Button>
			</Tooltip>
			<Dialog open={rosterOpen} onClose={() => setRosterOpen(false)}>
				<DialogTitle id="form-dialog-title">Game Roster</DialogTitle>
				<DialogContent>
					<GameRoster/>
				</DialogContent>
			</Dialog>
			<Dialog open={settingsOpen} onClose={() => setSettingsOpen(false)}>
				<DialogTitle id="form-dialog-title">Settings</DialogTitle>
				<DialogContent>
					<GameSettings/>
				</DialogContent>
			</Dialog>
			<Dialog open={socketData.lostConnection} onClose={() =>
			{
			}}>
				<DialogTitle id="form-dialog-title">Lost Connection</DialogTitle>
				<DialogContent>
					You have lost your connection to the server. Please check your connection, or retry. The most common reason for this to happen is switching tabs or leaving your browser for a while.
					<br/>
					<br/>
					If this behavior continues, please <a target={"_blank"} href={"https://github.com/jakelauer/allbadcards/issues/new?assignees=jakelauer&labels=bug&template=bug_report.md"}>click here</a> to report it.
				</DialogContent>
				<DialogActions>
					<Button color={"secondary"} variant={"outlined"} onClick={() => SocketDataStore.reconnect()}>Retry</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};